module.exports = __webpack_public_path__ + "img/background2.cd059d3a.jpg";